import React, { useMemo, useState } from "react";
import DropdownMenuDemo from "./PromotionRuleDropdown";
import { isObject } from "lodash";
import { promotionCreteria, PRODUCT_TYPE_IF_OPTIONS } from "./data";
import moment from "moment";

/** AND/OR join for category + brand rule — select dropdown (same link + menu pattern as category picker). */
const CATEGORY_AND_BRAND_JOIN_OPTIONS = [
  { title: "All (AND) — category and brand", value: "AND" },
  { title: "Any dimension (OR) — category or brand", value: "OR" },
];

/** Default nested node: same shape as standalone `product_type` IF rule (optional chain on category_and_brand). */
const CAB_CHAINED_PRODUCT_TYPE_DEFAULTS = {
  title: "Has a ",
  value: "category_and_brand_product_type",
  highlightText: "product type",
  type: "select",
  options: PRODUCT_TYPE_IF_OPTIONS,
  selectedValue: null,
  isOpen: false,
  isShowError: false,
  operation: "==",
  attributes: "product_type",
  endTitle: "",
};

function withChainedProductType(brandNode) {
  if (!brandNode) return brandNode;
  return {
    ...brandNode,
    groupRule: {
      ...CAB_CHAINED_PRODUCT_TYPE_DEFAULTS,
      ...(brandNode.groupRule || {}),
    },
  };
}

function IfRuleView({
  data,
  rulesStructure,
  setData,
  selectedRuleTypeRules,
  updateRulesRef,
  updateRuleValue,
  setMenuOpen,
  isMenuOpen,
  dropdownItems = [],
  isMenuHappenOpen,
  setMenuHappenOpen,
  getCategoryById = () => { },
  getGroupById = () => { },
  memoizeCategoryList = () => { },
  memoizeUserGroups = () => { },
  orderTotalExeedValue = 0,
  creteria,
  setCreteria,
  creteriaError,
  setCreteriaError,
}) {
  // const [creteria, setCreteria] = useState("");
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [productListOpenRuleId, setProductListOpenRuleId] = useState(null);
  const [subTraitListOpenRuleId, setSubTraitListOpenRuleId] = useState(null);
  const criteriaMenuOptions = useMemo(() => {
    return (promotionCreteria?.[data?.ruleType] || []).map((item) => ({
      title: item?.value,
      value: item?.id,
    }));
  }, [data?.ruleType]);

  // Only JSON-parse values that actually look like JSON.
  // This prevents plain strings like "vip_users" from being treated as [] (and falling back to highlightText).
  const parseJsonMaybe = (v) => {
    if (typeof v !== "string") return v;
    const t = v.trim();
    if (!t) return v;
    const looksLikeJson = t.startsWith("{") || t.startsWith("[");
    if (!looksLikeJson) return v;
    try {
      return JSON.parse(t);
    } catch {
      return v;
    }
  };
  return (
    <div className="cus-promotion-sec">
      {!data.ruleType && (
        <div className="d-flex align-item-center fs-large">
          <span>If</span>
          <DropdownMenuDemo
            key={"this rule"}
            menuTrigger={<> This</>}
            menuOptions={dropdownItems}
            isOpen={isMenuOpen}
            setOpen={() => setMenuOpen(!isMenuOpen)}
            ruleType="if"
            rule="this"
            selectRuleHandler={({ ruleValue }) => {
              setData({
                ...data,
                ruleType: ruleValue,
                isRuleSelected: false,
                ifRules: [],
                thenRules: [],
              });
            }}
            type="select"
            ruleId="if_rule"
            inputValue={data?.ruleType}
            showError={data.isRuleSelected}
          />
        </div>
      )}
      {data.ruleType && (
        <div className="d-flex align-item-center fs-large">
          <span>If</span>
          {/* Dropdown for selecting the rule type */}

          <DropdownMenuDemo
            key="this-rule"
            menuTrigger={
              <>{dropdownItems?.find((item) => item.value === data.ruleType)?.title || "This"}</>
            }
            menuOptions={dropdownItems}
            isOpen={isMenuOpen}
            setOpen={() => setMenuOpen(!isMenuOpen)}
            ruleType="if"
            rule="this"
            selectRuleHandler={({ ruleValue }) => {
              // Update data with the selected rule type and reset rules
              setData({
                ...data,
                ruleType: ruleValue,
                isRuleSelected: false,
                ifRules: [],
                thenRules: [],
              });
            }}
            type="select"
            ruleId="if_rule"
            inputValue={data?.ruleType}
            showError={data.isRuleSelected}
            resetCreteria={() => setCreteria("")}
          />
          {data.ifRules && (
            <DropdownMenuDemo
              key={`criteria-${data.ruleType}`}
              menuTrigger={
                <>
                  {promotionCreteria?.[data?.ruleType]?.find((i) => i.id === creteria)?.value ||
                    "Select Criteria"}
                </>
              }
              menuOptions={criteriaMenuOptions}
              isOpen={isSelectOpen}
              setOpen={() => setIsSelectOpen((v) => !v)}
              ruleType="if"
              rule="criteria"
              selectRuleHandler={({ ruleValue }) => {
                // Always refresh, even if selecting the same criteria again.
                setCreteria(ruleValue);
                setCreteriaError(false);
                setData((prev) => ({
                  ...prev,
                  creteria: ruleValue,
                  ifRules: [],
                  thenRules: [],
                }));
              }}
              type="select"
              ruleId="if_criteria"
              inputValue={creteria}
              showError={creteriaError}
            />
          )}

          {/* Dropdown for selecting 'Select' rule if no ifRules are present */}

          {data?.ifRules.length === 0 && creteria && (
            <DropdownMenuDemo
              key="happen-rule"
              menuTrigger={<> Select</>}
              menuOptions={selectedRuleTypeRules.ifRules || []}
              isOpen={isMenuHappenOpen}
              setOpen={() => setMenuHappenOpen(!isMenuHappenOpen)}
              ruleType="if"
              rule="happen"
              selectRuleHandler={({ ruleValue }) => {
                // Find and update the selected rule
                const selectedRule = rulesStructure[data.ruleType]?.[creteria].ifRules?.find(
                  (item) => item.value === ruleValue
                );
                let existingRule = [
                  ...data.ifRules,
                  { ...selectedRule, isOpen: false, isShowError: false },
                ];
                // Check for existing rules and remove duplicates
                const ifRuleArray = data.ifRules.some((item) =>
                  rulesStructure[data.ruleType]?.[creteria].ifRules.find(
                    (_item) => _item.value === item.value
                  )
                );
                if (ifRuleArray) {
                  let findRule = data.ifRules.find((item) =>
                    rulesStructure[data.ruleType]?.[creteria].ifRules.find(
                      (_item) => _item.value === item.value
                    )
                  );
                  if (findRule) {
                    existingRule = existingRule.filter((item) => item.value !== findRule.value);
                  }
                }
                // Update data with the new ifRules
                setData({
                  ...data,
                  ifRules: existingRule,
                  // thenRules: [],
                });
              }}
              type="select"
              // inputValue={data?.ruleType}
              showError={data.showError}
            // ruleId="if_rule"
            />
          )}
          {/* Render each ifRule with a dropdown for further selection */}
          {data?.ifRules?.map((ifRule) => (
            <React.Fragment key={ifRule.value}>
              {!(
                ifRule.isGroupRule &&
                ifRule.groupRule.value === "buy_product" &&
                ifRule.groupRule.selectedValue === "any_product"
              ) && (
                  <>
                    {ifRule?.title && (
                      <span>
                        {["first_purchase", "second_purchase", "third_purchase"].includes(ifRule?.attributes)
                          ? (ifRule.title.trimEnd() || "") + "\u00A0"
                          : ifRule.title}
                      </span>
                    )}
                    {ifRule.attributes === "each_or_any" &&
                      ifRule.selectedValue === "each" &&
                      ifRule.isGroupRule && (
                        <>
                          {ifRule.groupRule.title && <span>{ifRule.groupRule.title}</span>}
                          <DropdownMenuDemo
                            key={ifRule.groupRule.value}
                            menuTrigger={
                              <>
                                {ifRule?.groupRule?.inputType === "dollar" &&
                                  ifRule?.groupRule?.title &&
                                  "$"}
                                {Array.isArray(ifRule?.groupRule?.selectedValue) ? (
                                  ifRule.groupRule.selectedValue?.length > 0 ? (
                                    <>
                                      {ifRule.groupRule.selectedValue
                                        ?.slice(0, 2)
                                        .map((value) =>
                                          ifRule.groupRule?.listType === "category"
                                            ? `${value?.categoryName}`
                                            : ifRule.groupRule?.listType === "brand"
                                              ? `${value?.brandName}`
                                              : `${value?.display_name}`
                                        )
                                        .join(", ") || ifRule.highlightText}
                                      {ifRule?.groupRule?.selectedValue?.length > 2 && (
                                        <span
                                          className="chip"
                                          data-tooltip-id="tooltip"
                                          data-tooltip-content={
                                            ifRule.groupRule.selectedValue
                                              .map((value) =>
                                                ifRule.groupRule?.listType === "category"
                                                  ? `${value?.categoryName}`
                                                  : ifRule.groupRule?.listType === "brand"
                                                    ? `${value?.brandName}`
                                                    : `${value?.display_name}`
                                              )
                                              .join(", ") || ifRule.highlightText
                                          }
                                        >{`+${ifRule?.groupRule?.selectedValue?.length - 2}`}</span>
                                      )}
                                    </>
                                  ) : (
                                    ifRule.groupRule.highlightText
                                  )
                                ) : isObject(ifRule?.groupRule?.selectedValue) ? (
                                  ifRule?.groupRule?.listType === "category" ? (
                                    ifRule?.groupRule?.selectedValue?.categoryName || "category"
                                  ) : ifRule?.groupRule?.listType === "brand" ? (
                                    ifRule?.groupRule?.selectedValue?.brandName || "brand"
                                  ) : (
                                    ifRule?.groupRule?.selectedValue?.display_name || "product"
                                  )
                                ) : ifRule?.groupRule?.selectedValue === "any_product" ? (
                                  "Buy Any Product"
                                ) : (
                                  (ifRule?.groupRule?.type === "select" &&
                                    Array.isArray(ifRule?.groupRule?.options)
                                    ? ifRule.groupRule.options.find(
                                      (o) => o.value === ifRule.groupRule.selectedValue
                                    )?.title
                                    : null) ||
                                  ifRule?.groupRule?.selectedValue ||
                                  ifRule.groupRule.highlightText ||
                                  "Select"
                                )}
                                {ifRule?.groupRule?.inputType === "percentage" &&
                                  ifRule?.groupRule?.title &&
                                  "%"}
                              </>
                            }
                            menuOptions={
                              ifRule?.type === "select"
                                ? ifRule?.options
                                : selectedRuleTypeRules.ifRules || []
                            }
                            isOpen={ifRule.groupRule.isOpen}
                            setOpen={() => {
                              let updatedIfRules = [...updateRulesRef.current.ifRules].map((rule) => {
                                if (
                                  rule.groupRule &&
                                  rule.groupRule.value === ifRule.groupRule.value
                                ) {
                                  return {
                                    ...rule,
                                    groupRule: {
                                      ...rule.groupRule,
                                      isOpen: !rule.groupRule.isOpen,
                                      selectedValue: rule.groupRule.selectedValue,
                                    },
                                  };
                                }
                                return rule;
                              });
                              setData({
                                ...data,
                                ifRules: updatedIfRules,
                              });
                            }}
                            ruleType="if"
                            rule="happen"
                            selectRuleHandler={({ ruleValue }) => {
                              // Handle selection for 'select' type rules
                              if (
                                ifRule.groupRule.type === "select" ||
                                ifRule.groupRule.type === "list"
                              ) {
                                const selectedRule = data.ifRules?.find(
                                  (item) => item.groupRule.value === ifRule.groupRule.value
                                );
                                if (selectedRule) {
                                  const index = data.ifRules.indexOf(selectedRule);
                                  let existingRule = [...data.ifRules];
                                  existingRule[index] = {
                                    ...selectedRule,
                                    isOpen: false,
                                    isShowError: false,
                                    groupRule: {
                                      ...selectedRule.groupRule,
                                      selectedValue: ruleValue,
                                      isShowError: false,
                                      // highlightText: ruleValue,
                                    },
                                  };
                                  updateRulesRef.current = {
                                    ...data,
                                    ifRules: [...existingRule],
                                  };
                                  setData({
                                    ...data,
                                    ifRules: [...existingRule],
                                    // thenRules: [],
                                  });
                                }
                                return;
                              }
                              if (ifRule.groupRule.type === "input") {
                                const updatedRules = updateRuleValue({
                                  rules: data.ifRules,
                                  ruleValue,
                                  ruleId: ifRule.groupRule.value,
                                  isGroupRule: ifRule.isGroupRule,
                                });
                                setData({
                                  ...data,
                                  ifRules: updatedRules,
                                  // thenRules: [],
                                });
                                return;
                              }
                              // Update existing rules with the selected rule
                              let existingRule = [...data.ifRules];
                              const selectedRule = rulesStructure[data.ruleType]?.[
                                creteria
                              ].ifRules?.find((item) => item.value === ruleValue);
                              if (selectedRule) {
                                existingRule = [...existingRule, selectedRule];
                              }
                              // Remove duplicates from ifRules
                              const ifRuleArray = data.ifRules.some((item) =>
                                rulesStructure[data.ruleType]?.[creteria].ifRules.find(
                                  (_item) => _item.value === item.value
                                )
                              );
                              if (ifRuleArray) {
                                let findRule = data.ifRules.find((item) =>
                                  rulesStructure[data.ruleType]?.[creteria].ifRules.find(
                                    (_item) => _item.value === item.value
                                  )
                                );
                                if (findRule) {
                                  existingRule = existingRule.filter(
                                    (item) => item.value !== findRule?.value
                                  );
                                }
                              }
                              // Update data with the new ifRules
                              setData({
                                ...data,
                                ifRules: existingRule,
                                // thenRules: [],
                              });
                            }}
                            rules={selectedRuleTypeRules.ifRules}
                            type={ifRule.groupRule?.type}
                            inputType={ifRule.groupRule?.inputType}
                            listType={ifRule.groupRule?.listType}
                            ruleId={ifRule.groupRule?.value}
                            inputValue={ifRule.groupRule.selectedValue}
                            isGroupRule={ifRule.groupRule.isGroupRule}
                            showError={ifRule?.groupRule?.isShowError}
                          />

                          {!["each_or_any"].includes(ifRule?.attributes) && ifRule?.isGroupRule && (
                            <span>{ifRule?.groupRule?.endTitle}</span>
                          )}
                        </>
                      )}
                    {["first_purchase", "second_purchase", "third_purchase"].includes(ifRule?.attributes) ? (
                      <span>{` ${ifRule?.value ?? ""} `}</span>
                    ) : ifRule.value === "category_and_brand" ? (
                      <>
                        <DropdownMenuDemo
                          key="category_and_brand_category"
                          menuTrigger={
                            <>
                              {Array.isArray(ifRule.groupRule?.selectedValue) ? (
                                ifRule.groupRule.selectedValue?.length > 0 ? (
                                  <>
                                    {ifRule.groupRule.selectedValue
                                      ?.slice(0, 2)
                                      .map((value) => `${value?.categoryName}`)
                                      .join(", ") || ifRule.groupRule.highlightText}
                                    {ifRule.groupRule.selectedValue?.length > 2 && (
                                      <span
                                        className="chip"
                                        data-tooltip-id="tooltip"
                                        data-tooltip-content={
                                          ifRule.groupRule.selectedValue
                                            .map((value) => `${value?.categoryName}`)
                                            .join(", ") || ifRule.groupRule.highlightText
                                        }
                                      >{`+${ifRule.groupRule.selectedValue.length - 2}`}</span>
                                    )}
                                  </>
                                ) : (
                                  ifRule.groupRule?.highlightText || "category"
                                )
                              ) : isObject(ifRule.groupRule?.selectedValue) ? (
                                ifRule.groupRule?.selectedValue?.categoryName || "category"
                              ) : (
                                ifRule.groupRule?.highlightText || "category"
                              )}
                            </>
                          }
                          menuOptions={memoizeCategoryList}
                          isOpen={Boolean(ifRule.groupRule?.isOpen)}
                          setOpen={() => {
                            const updatedIfRules = [...updateRulesRef.current.ifRules].map((rule) => {
                              if (rule.value !== "category_and_brand") return rule;
                              const gr = rule.groupRule;
                              if (!gr) return rule;
                              return {
                                ...rule,
                                groupRule: {
                                  ...gr,
                                  isOpen: !gr.isOpen,
                                },
                              };
                            });
                            const next = { ...data, ifRules: updatedIfRules };
                            updateRulesRef.current = next;
                            setData(next);
                          }}
                          ruleType="if"
                          rule="happen"
                          selectRuleHandler={({ ruleValue }) => {
                            setData((prev) => {
                              const ifRules = prev.ifRules.map((r) =>
                                r.value !== "category_and_brand"
                                  ? r
                                  : {
                                      ...r,
                                      isShowError: false,
                                      groupRule: {
                                        ...r.groupRule,
                                        selectedValue: ruleValue,
                                        isOpen: false,
                                        isShowError: false,
                                        groupRule: withChainedProductType(r.groupRule?.groupRule),
                                      },
                                    }
                              );
                              const next = { ...prev, ifRules };
                              updateRulesRef.current = next;
                              return next;
                            });
                          }}
                          rules={selectedRuleTypeRules.ifRules}
                          type="list"
                          listType="category"
                          ruleId={ifRule.groupRule?.value}
                          inputValue={ifRule.groupRule?.selectedValue}
                          isGroupRule={false}
                          showError={ifRule.groupRule?.isShowError}
                        />
                        <DropdownMenuDemo
                          key="category_and_brand_join"
                          menuTrigger={
                            <span className="ms-1 me-1">
                              {ifRule.categoryBrandJoin === "OR" ? "or" : "and"}
                            </span>
                          }
                          menuOptions={CATEGORY_AND_BRAND_JOIN_OPTIONS}
                          isOpen={Boolean(ifRule.categoryBrandJoinIsOpen)}
                          setOpen={() => {
                            const updatedIfRules = [...updateRulesRef.current.ifRules].map((rule) => {
                              if (rule.value !== "category_and_brand") return rule;
                              return {
                                ...rule,
                                categoryBrandJoinIsOpen: !rule.categoryBrandJoinIsOpen,
                              };
                            });
                            const next = { ...data, ifRules: updatedIfRules };
                            updateRulesRef.current = next;
                            setData(next);
                          }}
                          ruleType="if"
                          rule="happen"
                          selectRuleHandler={({ ruleValue }) => {
                            setData((prev) => {
                              const ifRules = prev.ifRules.map((r) =>
                                r.value !== "category_and_brand"
                                  ? r
                                  : {
                                      ...r,
                                      categoryBrandJoin: ruleValue,
                                      categoryBrandJoinIsOpen: false,
                                      isShowError: false,
                                    }
                              );
                              const next = { ...prev, ifRules };
                              updateRulesRef.current = next;
                              return next;
                            });
                          }}
                          type="select"
                          ruleId="category_brand_join"
                          inputValue={ifRule.categoryBrandJoin === "OR" ? "OR" : "AND"}
                          showError={false}
                        />
                        <DropdownMenuDemo
                          key="category_and_brand_brand"
                          menuTrigger={
                            <>
                              {Array.isArray(ifRule.groupRule?.groupRule?.selectedValue) ? (
                                ifRule.groupRule.groupRule.selectedValue?.length > 0 ? (
                                  <>
                                    {ifRule.groupRule.groupRule.selectedValue
                                      ?.slice(0, 2)
                                      .map((value) => `${value?.brandName}`)
                                      .join(", ") || ifRule.groupRule.groupRule.highlightText}
                                    {ifRule.groupRule.groupRule.selectedValue?.length > 2 && (
                                      <span
                                        className="chip"
                                        data-tooltip-id="tooltip"
                                        data-tooltip-content={
                                          ifRule.groupRule.groupRule.selectedValue
                                            .map((value) => `${value?.brandName}`)
                                            .join(", ") || ifRule.groupRule.groupRule.highlightText
                                        }
                                      >{`+${ifRule.groupRule.groupRule.selectedValue.length - 2}`}</span>
                                    )}
                                  </>
                                ) : (
                                  ifRule.groupRule?.groupRule?.highlightText || "brand"
                                )
                              ) : isObject(ifRule.groupRule?.groupRule?.selectedValue) ? (
                                ifRule.groupRule?.groupRule?.selectedValue?.brandName || "brand"
                              ) : (
                                ifRule.groupRule?.groupRule?.highlightText || "brand"
                              )}
                            </>
                          }
                          menuOptions={[]}
                          isOpen={Boolean(ifRule.groupRule?.groupRule?.isOpen)}
                          setOpen={() => {
                            const updatedIfRules = [...updateRulesRef.current.ifRules].map((rule) => {
                              if (rule.value !== "category_and_brand") return rule;
                              const gr = rule.groupRule?.groupRule;
                              if (!rule.groupRule || !gr) return rule;
                              return {
                                ...rule,
                                groupRule: {
                                  ...rule.groupRule,
                                  groupRule: {
                                    ...gr,
                                    isOpen: !gr.isOpen,
                                  },
                                },
                              };
                            });
                            const next = { ...data, ifRules: updatedIfRules };
                            updateRulesRef.current = next;
                            setData(next);
                          }}
                          ruleType="if"
                          rule="happen"
                          selectRuleHandler={({ ruleValue }) => {
                            setData((prev) => {
                              const ifRules = prev.ifRules.map((r) =>
                                r.value !== "category_and_brand" || !r.groupRule
                                  ? r
                                  : {
                                      ...r,
                                      isShowError: false,
                                      groupRule: {
                                        ...r.groupRule,
                                        groupRule: withChainedProductType({
                                          ...r.groupRule?.groupRule,
                                          selectedValue: ruleValue,
                                          isOpen: false,
                                          isShowError: false,
                                        }),
                                      },
                                    }
                              );
                              const next = { ...prev, ifRules };
                              updateRulesRef.current = next;
                              return next;
                            });
                          }}
                          rules={selectedRuleTypeRules.ifRules}
                          type="list"
                          listType="brand"
                          ruleId={ifRule.groupRule?.groupRule?.value}
                          inputValue={ifRule.groupRule?.groupRule?.selectedValue}
                          isGroupRule={false}
                          showError={ifRule.groupRule?.groupRule?.isShowError}
                        />
                        <span className="ms-1 me-1">and&nbsp;</span>
                        {ifRule.groupRule?.groupRule?.groupRule?.title ? (
                          <span className="me-1">{ifRule.groupRule.groupRule.groupRule.title}</span>
                        ) : null}
                        <DropdownMenuDemo
                          key="category_and_brand_product_type"
                          menuTrigger={
                            <>
                              {ifRule.groupRule?.groupRule?.groupRule?.type === "select" &&
                              Array.isArray(ifRule.groupRule.groupRule.groupRule.options) ? (
                                (() => {
                                  const pt = ifRule.groupRule.groupRule.groupRule;
                                  const uiVal = pt.selectedValue;
                                  const opt = pt.options.find((o) => o.value === uiVal);
                                  return (
                                    opt?.title ||
                                    opt?.highLightText ||
                                    pt.highlightText ||
                                    "product type"
                                  );
                                })()
                              ) : (
                                ifRule.groupRule?.groupRule?.groupRule?.highlightText || "product type"
                              )}
                            </>
                          }
                          menuOptions={
                            ifRule.groupRule?.groupRule?.groupRule?.options ?? PRODUCT_TYPE_IF_OPTIONS
                          }
                          isOpen={Boolean(ifRule.groupRule?.groupRule?.groupRule?.isOpen)}
                          setOpen={() => {
                            const updatedIfRules = [...updateRulesRef.current.ifRules].map((rule) => {
                              if (rule.value !== "category_and_brand") return rule;
                              const b = rule.groupRule?.groupRule;
                              if (!rule.groupRule || !b) return rule;
                              const pt = b.groupRule || { ...CAB_CHAINED_PRODUCT_TYPE_DEFAULTS };
                              return {
                                ...rule,
                                groupRule: {
                                  ...rule.groupRule,
                                  groupRule: {
                                    ...b,
                                    groupRule: {
                                      ...CAB_CHAINED_PRODUCT_TYPE_DEFAULTS,
                                      ...pt,
                                      isOpen: !pt.isOpen,
                                    },
                                  },
                                },
                              };
                            });
                            const next = { ...data, ifRules: updatedIfRules };
                            updateRulesRef.current = next;
                            setData(next);
                          }}
                          ruleType="if"
                          rule="happen"
                          selectRuleHandler={({ ruleValue }) => {
                            setData((prev) => {
                              const ifRules = prev.ifRules.map((r) => {
                                if (r.value !== "category_and_brand" || !r.groupRule) return r;
                                const b = r.groupRule.groupRule;
                                const pt = {
                                  ...CAB_CHAINED_PRODUCT_TYPE_DEFAULTS,
                                  ...(b?.groupRule || {}),
                                  selectedValue: ruleValue,
                                  isOpen: false,
                                  isShowError: false,
                                };
                                return {
                                  ...r,
                                  isShowError: false,
                                  groupRule: {
                                    ...r.groupRule,
                                    groupRule: withChainedProductType({
                                      ...(b || {}),
                                      groupRule: pt,
                                    }),
                                  },
                                };
                              });
                              const next = { ...prev, ifRules };
                              updateRulesRef.current = next;
                              return next;
                            });
                          }}
                          type="select"
                          ruleId={ifRule.groupRule?.groupRule?.groupRule?.value ?? "category_and_brand_product_type"}
                          inputValue={ifRule.groupRule?.groupRule?.groupRule?.selectedValue ?? null}
                          showError={ifRule.groupRule?.groupRule?.groupRule?.isShowError}
                        />
                      </>
                    ) : (
                    <DropdownMenuDemo
                      key={ifRule.value}
                      menuTrigger={
                        <>
                          {ifRule?.inputType === "dollar" && ifRule?.title && "$"}
                          {ifRule?.type === "list" && ifRule.listType === "category" ? (
                            (() => {
                              const val = typeof ifRule?.selectedValue === 'string' ? (() => { try { return JSON.parse(ifRule.selectedValue) } catch (e) { return ifRule.selectedValue } })() : ifRule.selectedValue;
                              return val?.categoryName || getCategoryById(val)?.categoryName || "selected category";
                            })()
                          ) : ifRule?.type === "list" && ifRule.listType === "brand" ? (
                            (() => {
                              const val = typeof ifRule?.selectedValue === 'string' ? (() => { try { return JSON.parse(ifRule.selectedValue) } catch (e) { return ifRule.selectedValue } })() : ifRule.selectedValue;
                              return val?.brandName || "selected brand";
                            })()
                          ) : ifRule?.type === "list" && ifRule.listType === "region" ? (
                            (() => {
                              const val = typeof ifRule?.selectedValue === 'string' ? (() => { try { return JSON.parse(ifRule.selectedValue) } catch (e) { return ifRule.selectedValue } })() : ifRule.selectedValue;
                              return val?.regionName || ifRule.highlightText || "specific region";
                            })()
                          ) : ifRule?.type === "date_range" ? (
                            (() => {
                              const val = typeof ifRule?.selectedValue === 'string' ? (() => { try { return JSON.parse(ifRule.selectedValue) } catch (e) { return ifRule.selectedValue } })() : ifRule.selectedValue;
                              if (val?.startDate) {
                                return `${moment(val.startDate).format("MMM DD, HH:mm")} - ${moment(val.endDate).format("MMM DD, HH:mm")}`;
                              }
                              return ifRule.highlightText || "specific period";
                            })()
                          ) : ifRule?.type === "list" && ifRule.listType === "user_group" ? (
                            getGroupById(ifRule?.selectedValue ?? ifRule?.selectedvalue)?.title || "Select"
                          ) : Array.isArray(parseJsonMaybe(ifRule?.selectedValue ?? ifRule?.selectedvalue)) ? (
                            (() => {
                              const selectedVal = parseJsonMaybe(ifRule?.selectedValue ?? ifRule?.selectedvalue) || [];
                              return (
                                <>
                                  {selectedVal
                                    ?.slice(0, 2)
                                    .map((value) =>
                                      ifRule.listType === "category"
                                        ? `${value?.categoryName}`
                                        : ifRule.listType === "brand"
                                          ? `${value?.brandName}`
                                          : ifRule.listType === "region"
                                            ? `${value?.regionName}`
                                        : ifRule.listType === "weekdays"
                                              ? `${value?.title}`
                                              : `${value?.display_name}`
                                    )
                                    .join(", ") || ifRule.highlightText}
                                  {selectedVal.length > 2 && (
                                    <span
                                      className="chip"
                                      data-tooltip-id="tooltip"
                                      data-tooltip-content={
                                        selectedVal
                                          .map((value) =>
                                            ifRule.listType === "category"
                                              ? `${value?.categoryName}`
                                              : ifRule.listType === "brand"
                                                ? `${value?.brandName}`
                                                : ifRule.listType === "region"
                                                  ? `${value?.regionName}`
                                                  : ifRule.listType === "weekdays"
                                                    ? `${value?.title}`
                                                    : `${value?.display_name}`
                                          )
                                          .join(", ") || ifRule.highlightText
                                      }
                                    >{`+${selectedVal.length - 2}`}</span>
                                  )}
                                </>
                              );
                            })()
                          ) : ifRule?.type === "one-level" && ifRule?.attributes === "product_trait" ? (
                            (() => {
                              const val = ifRule?.selectedValue ?? ifRule?.selectedvalue;
                              if (val && typeof val === "object") return val?.mainTraitName ?? val?.traitName ?? val?.name ?? "Select trait";
                              return "Select trait";
                            })()
                          ) : ifRule?.type === "one-level" && ifRule?.attributes === "product_strain" ? (
                            (() => {
                              const val = ifRule?.selectedValue ?? ifRule?.selectedvalue;
                              if (val && typeof val === "object") return val?.strainName ?? val?.name ?? val?.slug ?? "Select strain";
                              return "Select strain";
                            })()
                          ) : isObject(parseJsonMaybe(ifRule?.selectedValue ?? ifRule?.selectedvalue)) ? (
                            (() => {
                              const val = parseJsonMaybe(ifRule?.selectedValue ?? ifRule?.selectedvalue);
                              return ifRule.listType === "brand" ? (
                                `${val?.brandName}`
                              ) : ifRule.listType === "region" ? (
                                `${val?.regionName}`
                              ) : ifRule.listType === "weekdays" ? (
                                `${val?.title}`
                              ) : (
                                `${val?.display_name}`
                              );
                            })()
                          ) : (
                            (ifRule?.type === "select" && Array.isArray(ifRule?.options)
                              ? (() => {
                                const uiVal = ifRule?.selectedValue ?? ifRule?.selectedvalue;
                                const opt = ifRule.options.find((o) => o.value === uiVal);
                                return opt?.title || opt?.highLightText || "";
                              })()
                              : null) ||
                            (ifRule?.selectedValue ?? ifRule?.selectedvalue) ||
                            ifRule.highlightText ||
                            ""
                          )}
                          {ifRule?.inputType === "percentage" && ifRule?.title && "%"}
                        </>
                      }
                      menuOptions={
                        ifRule?.type === "list" && ifRule.listType === "category"
                          ? memoizeCategoryList
                          : ifRule?.type === "list" && ifRule.listType === "brand"
                            ? []
                            : ifRule?.type === "list" && ifRule.listType === "user_group"
                              ? memoizeUserGroups
                              : ifRule?.type === "list" && ifRule.listType === "weekdays"
                                ? []
                                : ifRule?.type === "select"
                                  ? ifRule?.options
                                  : selectedRuleTypeRules.ifRules || []
                      }
                      isOpen={isMenuHappenOpen}
                      setOpen={() => setMenuHappenOpen(!isMenuHappenOpen)}
                      ruleType="if"
                      rule="happen"
                      selectRuleHandler={({ ruleValue }) => {
                        // Handle selection for 'select' type rules, list, date_range, or one-level (e.g. trait)
                        if (ifRule.type === "select" || ifRule?.type === "list" || ifRule?.type === "date_range" || ifRule?.type === "one-level") {
                          const selectedRule = data.ifRules?.find(
                            (item) => item.value === ifRule.value
                          );
                          if (selectedRule) {
                            const index = data.ifRules.indexOf(selectedRule);
                            let existingRule = [...data.ifRules];
                            const isTraitRule = selectedRule?.attributes === "product_trait";
                            existingRule[index] = {
                              ...selectedRule,
                              selectedValue: ruleValue,
                              ...(isTraitRule ? { selectedSubTraits: [] } : {}),
                              isShowError: false,
                              isOpen: false,
                            };
                            setData({
                              ...data,
                              ifRules: [...existingRule],
                              // thenRules: [],
                            });
                          }
                          return;
                        }
                        if (ifRule.type === "input") {
                          const updatedRules = updateRuleValue({
                            rules: data.ifRules,
                            ruleValue,
                            ruleId: ifRule.value,
                            isGroupRule: false,
                          });
                          if (ifRule.value === "total_exceeds") {
                            const updatedThenRules = updateRuleValue({
                              rules: data.thenRules,
                              ruleValue: "",
                              ruleId: "flat_discount",
                              isGroupRule: false,
                            });
                            setData({
                              ...data,
                              ifRules: updatedRules,
                              thenRules: updatedThenRules,
                            });
                            return;
                          }
                          setData({
                            ...data,
                            ifRules: updatedRules,
                          });
                          return;
                        }
                        // Update existing rules with the selected rule
                        let existingRule = [...data.ifRules];
                        const selectedRule = rulesStructure[data.ruleType]?.[creteria].ifRules?.find(
                          (item) => item.value === ruleValue
                        );
                        if (selectedRule) {
                          existingRule = [...existingRule, selectedRule];
                        }
                        // Remove duplicates from ifRules
                        const ifRuleArray = data.ifRules.some((item) =>
                          rulesStructure[data.ruleType]?.[creteria].ifRules.find(
                            (_item) => _item.value === item.value
                          )
                        );
                        if (ifRuleArray) {
                          let findRule = data.ifRules.find((item) =>
                            rulesStructure[data.ruleType]?.[creteria].ifRules.find(
                              (_item) => _item.value === item.value
                            )
                          );
                          if (findRule) {
                            existingRule = existingRule.filter(
                              (item) => item.value !== findRule?.value
                            );
                          }
                        }
                        // Update data with the new ifRules
                        setData({
                          ...data,
                          ifRules: existingRule,
                          // thenRules: [],
                        });
                      }}
                      inputValue={ifRule?.selectedValue ?? ifRule?.selectedvalue}
                      type={ifRule?.type}
                      inputType={ifRule?.inputType}
                      listType={ifRule?.listType}
                      ruleId={ifRule?.value}
                      rules={selectedRuleTypeRules.ifRules}
                      showError={ifRule.isShowError}
                      maxInputValue={orderTotalExeedValue}
                      attributes={ifRule?.attributes}
                    />
                  )}
                  </>
                )}

              {ifRule?.endTitle && (
                <span>
                  {["first_purchase", "second_purchase", "third_purchase"].includes(ifRule?.attributes)
                    ? "\u00A0"
                    : ""}
                  {ifRule?.endTitle || ""}
                  {/* Dialog-only spacing between endTitle + next nested token (e.g. "edition on") */}
                  {ifRule?.value === "product_new_arrival" && ifRule?.selectedValue === "new_arrival"
                    ? "\u00A0"
                    : ""}
                </span>
              )}

              {ifRule?.type === "one-level" && ifRule?.attributes === "product_trait" && ifRule?.selectedValue && (
                <DropdownMenuDemo
                  key={`${ifRule.value}-subtraits`}
                  menuTrigger={
                    (() => {
                      const subs = ifRule?.selectedSubTraits ?? [];
                      const arr = Array.isArray(subs) ? subs : [];
                      if (arr.length === 0) return "Select sub-traits";
                      if (arr.length === 1) return arr[0]?.subTraitName ?? arr[0]?.name ?? "1 sub-trait";
                      return `${arr.length} sub-traits`;
                    })()
                  }
                  isOpen={subTraitListOpenRuleId === ifRule.value}
                  setOpen={() => setSubTraitListOpenRuleId((prev) => (prev === ifRule.value ? null : ifRule.value))}
                  ruleType="if"
                  rule="happen"
                  selectRuleHandler={({ ruleValue }) => {
                    const selectedRule = data.ifRules?.find((item) => item.value === ifRule.value);
                    if (selectedRule) {
                      const index = data.ifRules.indexOf(selectedRule);
                      const updated = [...data.ifRules];
                      updated[index] = { ...selectedRule, selectedSubTraits: Array.isArray(ruleValue) ? ruleValue : [] };
                      setData({ ...data, ifRules: updated });
                    }
                  }}
                  type="one-level"
                  attributes="product_trait"
                  listType="sub_trait"
                  traitId={ifRule.selectedValue?._id}
                  inputValue={ifRule?.selectedSubTraits ?? []}
                  ruleId={`${ifRule.value}-subtraits`}
                />
              )}

              {ifRule?.type === "one-level" && (ifRule?.attributes === "product_trait" || ifRule?.attributes === "product_strain") && (
                <DropdownMenuDemo
                  key={`${ifRule.value}-products`}
                  menuTrigger={
                    (() => {
                      const products = ifRule?.selectedProducts ?? [];
                      const arr = Array.isArray(products) ? products : [];
                      if (arr.length === 0) return "Select products";
                      if (arr.length === 1) return arr[0]?.display_name ?? arr[0]?.productName ?? "1 product";
                      return `${arr.length} products`;
                    })()
                  }
                  isOpen={productListOpenRuleId === ifRule.value}
                  setOpen={() => setProductListOpenRuleId((prev) => (prev === ifRule.value ? null : ifRule.value))}
                  ruleType="if"
                  rule="happen"
                  selectRuleHandler={({ ruleValue }) => {
                    const selectedRule = data.ifRules?.find((item) => item.value === ifRule.value);
                    if (selectedRule) {
                      const index = data.ifRules.indexOf(selectedRule);
                      const updated = [...data.ifRules];
                      updated[index] = { ...selectedRule, selectedProducts: ruleValue ?? [] };
                      setData({ ...data, ifRules: updated });
                    }
                    setProductListOpenRuleId(null);
                  }}
                  type="list"
                  listType="product"
                  inputValue={ifRule?.selectedProducts ?? []}
                  ruleId={`${ifRule.value}-products`}
                />
              )}

              {ifRule.groupRule?.isGroupRule && ifRule.groupRule.title && (
                <span>{ifRule.groupRule.title}</span>
              )}
              {ifRule.attributes === "each_or_any" &&
                ifRule.selectedValue === "each" ? null : ifRule.isGroupRule &&
                  ifRule.groupRule.value === "till_date" ? (
                <>
                  {ifRule.groupRule.title && <span>{ifRule.groupRule.title}</span>}
                  <DropdownMenuDemo
                    key={ifRule.groupRule.value}
                    menuTrigger={
                      <>
                        {ifRule.groupRule.selectedValue &&
                          moment(ifRule.groupRule.selectedValue).isValid()
                          ? moment(ifRule.groupRule.selectedValue).format("YYYY-MM-DD")
                          : ifRule.groupRule.highlightText || "Select"}
                      </>
                    }
                    isOpen={ifRule.groupRule.isOpen}
                    setOpen={() => {
                      let updatedIfRules = [...updateRulesRef.current.ifRules].map((rule) => {
                        if (rule.groupRule && rule.groupRule.value === ifRule.groupRule.value) {
                          return {
                            ...rule,
                            groupRule: {
                              ...rule.groupRule,
                              isOpen: !rule.groupRule.isOpen,
                              selectedValue: rule.groupRule.selectedValue,
                            },
                          };
                        }
                        return rule;
                      });
                      setData({
                        ...data,
                        ifRules: updatedIfRules,
                      });
                    }}
                    ruleType="if"
                    rule="happen"
                    selectRuleHandler={({ ruleValue }) => {
                      const updatedRules = updateRuleValue({
                        rules: data.ifRules,
                        ruleValue,
                        ruleId: ifRule.groupRule.value,
                        isGroupRule: ifRule.isGroupRule,
                      });
                      updateRulesRef.current = {
                        ...data,
                        ifRules: updatedRules,
                      };
                      setData({
                        ...data,
                        ifRules: updatedRules,
                      });
                    }}
                    type="input"
                    inputType={ifRule.groupRule.inputType}
                    inputValue={ifRule.groupRule.selectedValue}
                    showError={ifRule.groupRule.isShowError}
                    ruleId={ifRule.groupRule.value}
                  />
                </>
              ) : (
                <>
                  {ifRule.isGroupRule &&
                    // Show "New Arrival date" only when New Arrival selected
                    (ifRule.value !== "product_new_arrival" ||
                      ifRule.selectedValue === "new_arrival") && (
                    <>
                      {ifRule.groupRule.title && <span>{ifRule.groupRule.title}</span>}
                      <DropdownMenuDemo
                        key={ifRule.groupRule.value}
                        menuTrigger={
                          <>
                            {ifRule?.groupRule?.inputType === "dollar" &&
                              ifRule?.groupRule?.title &&
                              "$"}
                            {Array.isArray(ifRule?.groupRule?.selectedValue) ? (
                              ifRule.groupRule.selectedValue?.length > 0 ? (
                                <>
                                  {ifRule.groupRule.selectedValue
                                    ?.slice(0, 2)
                                    .map((value) =>
                                      ifRule.groupRule?.listType === "category"
                                        ? `${value?.categoryName}`
                                        : ifRule.groupRule?.listType === "brand"
                                          ? `${value?.brandName}`
                                          : `${value?.display_name}`
                                    )
                                    .join(", ") || ifRule.highlightText}
                                  {ifRule?.groupRule?.selectedValue?.length > 2 && (
                                    <span
                                      className="chip"
                                      data-tooltip-id="tooltip"
                                      data-tooltip-content={
                                        ifRule.groupRule.selectedValue
                                          .map((value) =>
                                            ifRule.groupRule?.listType === "category"
                                              ? `${value?.categoryName}`
                                              : ifRule.groupRule?.listType === "brand"
                                                ? `${value?.brandName}`
                                                : `${value?.display_name}`
                                          )
                                          .join(", ") || ifRule.highlightText
                                      }
                                    >{`+${ifRule?.groupRule?.selectedValue?.length - 2}`}</span>
                                  )}
                                </>
                              ) : (
                                ifRule.groupRule.highlightText
                              )
                            ) : isObject(ifRule?.groupRule?.selectedValue) ? (
                              ifRule?.groupRule?.listType === "category" ? (
                                ifRule?.groupRule?.selectedValue?.categoryName || "category"
                              ) : ifRule?.groupRule?.listType === "brand" ? (
                                ifRule?.groupRule?.selectedValue?.brandName || "brand"
                              ) : (
                                ifRule?.groupRule?.selectedValue?.display_name || "product"
                              )
                            ) : ifRule?.groupRule?.selectedValue === "any_product" ? (
                              "Buy Any Product"
                            ) : (
                              (ifRule?.groupRule?.type === "select" &&
                                Array.isArray(ifRule?.groupRule?.options)
                                ? ifRule.groupRule.options.find(
                                  (o) => o.value === ifRule.groupRule.selectedValue
                                )?.title
                                : null) ||
                              ifRule?.groupRule?.selectedValue ||
                              ifRule.groupRule.highlightText ||
                              "Select"
                            )}
                            {ifRule?.groupRule?.inputType === "percentage" &&
                              ifRule?.groupRule?.title &&
                              "%"}
                          </>
                        }
                        menuOptions={
                          ifRule.groupRule?.listType === "category"
                            ? memoizeCategoryList
                            : ifRule.groupRule?.listType === "brand"
                              ? [] // Brands are fetched internally in BrandList
                              : ifRule.groupRule?.listType === "weekdays"
                                ? []
                                : ifRule?.type === "select"
                                  ? ifRule?.options
                                  : selectedRuleTypeRules.ifRules || []
                        }
                        isOpen={ifRule.groupRule.isOpen}
                        setOpen={() => {
                          let updatedIfRules = [...updateRulesRef.current.ifRules].map((rule) => {
                            if (rule.groupRule && rule.groupRule.value === ifRule.groupRule.value) {
                              return {
                                ...rule,
                                groupRule: {
                                  ...rule.groupRule,
                                  isOpen: !rule.groupRule.isOpen,
                                  selectedValue: rule.groupRule.selectedValue,
                                },
                              };
                            }
                            return rule;
                          });
                          setData({
                            ...data,
                            ifRules: updatedIfRules,
                          });
                        }}
                        ruleType="if"
                        rule="happen"
                        selectRuleHandler={({ ruleValue }) => {
                          // Handle selection for 'select' type rules
                          if (
                            ifRule.groupRule.type === "select" ||
                            ifRule.groupRule.type === "list"
                          ) {
                            const selectedRule = data.ifRules?.find(
                              (item) => item.groupRule.value === ifRule.groupRule.value
                            );
                            if (selectedRule) {
                              const index = data.ifRules.indexOf(selectedRule);
                              let existingRule = [...data.ifRules];
                              existingRule[index] = {
                                ...selectedRule,
                                isOpen: false,
                                isShowError: false,
                                groupRule: {
                                  ...selectedRule.groupRule,
                                  selectedValue: ruleValue,
                                  isShowError: false,
                                  // highlightText: ruleValue,
                                },
                              };
                              updateRulesRef.current = {
                                ...data,
                                ifRules: [...existingRule],
                              };
                              setData({
                                ...data,
                                ifRules: [...existingRule],
                                // thenRules: [],
                              });
                            }
                            return;
                          }
                          if (ifRule.groupRule.type === "input") {
                            const updatedRules = updateRuleValue({
                              rules: data.ifRules,
                              ruleValue,
                              ruleId: ifRule.groupRule.value,
                              isGroupRule: ifRule.isGroupRule,
                            });
                            setData({
                              ...data,
                              ifRules: updatedRules,
                              // thenRules: [],
                            });
                            return;
                          }
                          // Update existing rules with the selected rule
                          let existingRule = [...data.ifRules];
                          const selectedRule = rulesStructure[data.ruleType]?.[
                            creteria
                          ].ifRules?.find((item) => item.value === ruleValue);
                          if (selectedRule) {
                            existingRule = [...existingRule, selectedRule];
                          }
                          // Remove duplicates from ifRules
                          const ifRuleArray = data.ifRules.some((item) =>
                            rulesStructure[data.ruleType]?.[creteria].ifRules.find(
                              (_item) => _item.value === item.value
                            )
                          );
                          if (ifRuleArray) {
                            let findRule = data.ifRules.find((item) =>
                              rulesStructure[data.ruleType]?.[creteria].ifRules.find(
                                (_item) => _item.value === item.value
                              )
                            );
                            if (findRule) {
                              existingRule = existingRule.filter(
                                (item) => item.value !== findRule?.value
                              );
                            }
                          }
                          // Update data with the new ifRules
                          setData({
                            ...data,
                            ifRules: existingRule,
                            // thenRules: [],
                          });
                        }}
                        rules={selectedRuleTypeRules.ifRules}
                        type={ifRule.groupRule?.type}
                        inputType={ifRule.groupRule?.inputType}
                        listType={ifRule.groupRule?.listType}
                        ruleId={ifRule.groupRule?.value}
                        inputValue={ifRule.groupRule.selectedValue}
                        isGroupRule={ifRule.groupRule.isGroupRule}
                        showError={ifRule?.groupRule?.isShowError}
                      />

                      {!["each_or_any"].includes(ifRule?.attributes) && ifRule?.isGroupRule && (
                        <span>{ifRule?.groupRule?.endTitle}</span>
                      )}
                    </>
                  )}
                </>
              )}

              {!["cart"].includes(ifRule.groupRule?.selectedValue) &&
                ifRule.groupRule?.groupRule &&
                ifRule.groupRule?.isGroupRule && (
                  <>
                    <DropdownMenuDemo
                      key={ifRule.groupRule?.groupRule.value}
                      menuTrigger={
                        <>
                          {ifRule?.groupRule?.groupRule?.inputType === "dollar" &&
                            ifRule?.groupRule?.groupRule?.title &&
                            "$"}
                          {Array.isArray(ifRule?.groupRule?.groupRule?.selectedValue) ? (
                            ifRule.groupRule?.groupRule.selectedValue?.length > 0 ? (
                              <>
                                {ifRule.groupRule?.groupRule.selectedValue
                                  ?.slice(0, 2)
                                  .map((value) =>
                                    ifRule.groupRule?.groupRule?.listType === "category"
                                      ? `${value?.categoryName}`
                                      : ifRule.groupRule?.groupRule?.listType === "brand"
                                        ? `${value?.brandName}`
                                        : `${value?.display_name}`
                                  )
                                  .join(", ") || ifRule.groupRule?.groupRule.highlightText}
                                {ifRule.groupRule?.groupRule.selectedValue.length > 2 && (
                                  <span
                                    className="chip"
                                    data-tooltip-id="tooltip"
                                    data-tooltip-content={
                                      ifRule.groupRule?.groupRule.selectedValue
                                        .map((value) =>
                                          ifRule.groupRule?.groupRule?.listType === "category"
                                            ? `${value?.categoryName}`
                                            : ifRule.groupRule?.groupRule?.listType === "brand"
                                              ? `${value?.brandName}`
                                              : `${value?.display_name}`
                                        )
                                        .join(", ") || ifRule.groupRule?.groupRule.highlightText
                                    }
                                  >{`+${ifRule.groupRule?.groupRule.selectedValue.length - 2
                                    }`}</span>
                                )}
                              </>
                            ) : (
                              ifRule.groupRule?.groupRule.highlightText
                            )
                          ) : isObject(ifRule?.groupRule?.groupRule?.selectedValue) ? (
                            ifRule?.groupRule?.groupRule?.listType === "category" ? (
                              ifRule?.groupRule?.groupRule?.selectedValue?.categoryName ||
                              "category"
                            ) : ifRule?.groupRule?.groupRule?.listType === "brand" ? (
                              ifRule?.groupRule?.groupRule?.selectedValue?.brandName || "brand"
                            ) : (
                              ifRule?.groupRule?.groupRule?.selectedValue?.display_name || "product"
                            )
                          ) : ifRule?.groupRule?.groupRule.selectedValue === "any_product" ? (
                            "Then Get Any Product"
                          ) : (
                            (ifRule?.groupRule?.groupRule?.type === "select" &&
                              Array.isArray(ifRule?.groupRule?.groupRule?.options)
                              ? ifRule.groupRule.groupRule.options.find(
                                (o) => o.value === ifRule.groupRule.groupRule.selectedValue
                              )?.title
                              : null) ||
                            ifRule?.groupRule?.groupRule?.selectedValue ||
                            ifRule.groupRule?.groupRule.highlightText ||
                            "Select"
                          )}
                          {ifRule?.groupRule?.groupRule?.inputType === "percentage" &&
                            ifRule?.groupRule?.groupRule?.title &&
                            "%"}
                        </>
                      }
                      menuOptions={
                        ifRule.groupRule?.groupRule.type === "select"
                          ? ifRule.groupRule?.groupRule.options
                          : selectedRuleTypeRules.ifRules || []
                      }
                      isOpen={ifRule.groupRule?.groupRule.isOpen}
                      setOpen={() => {
                        let updatedIfRules = [...updateRulesRef.current.ifRules].map((rule) => {
                          if (
                            rule.groupRule?.groupRule.value === ifRule.groupRule?.groupRule.value &&
                            rule.groupRule?.groupRule
                          ) {
                            return {
                              ...rule,
                              groupRule: {
                                ...rule.groupRule,
                                groupRule: {
                                  ...rule.groupRule?.groupRule,
                                  isOpen: !rule.groupRule?.groupRule.isOpen,
                                },
                              },
                            };
                          }
                          return rule;
                        });
                        updateRulesRef.current = {
                          ...data,
                          ifRules: [...updatedIfRules],
                        };
                        setData({
                          ...data,
                          ifRules: updatedIfRules,
                        });
                      }}
                      ruleType="then"
                      rule="happen"
                      selectRuleHandler={({ ruleValue }) => {
                        if (
                          ifRule.groupRule?.groupRule?.type === "select" ||
                          ifRule.groupRule?.groupRule?.type === "list"
                        ) {
                          const selectedRule = [...updateRulesRef.current.ifRules]?.find(
                            (item) =>
                              item.groupRule?.groupRule?.value ===
                              ifRule.groupRule?.groupRule?.value
                          );
                          if (selectedRule) {
                            const index = data.ifRules.indexOf(selectedRule);
                            let existingRule = [...data.ifRules];
                            existingRule[index] = {
                              ...selectedRule,
                              isOpen: false,
                              isShowError: false,
                              groupRule: {
                                ...selectedRule.groupRule,
                                groupRule: {
                                  ...selectedRule.groupRule?.groupRule,
                                  selectedValue: ruleValue,
                                  isShowError: false,
                                  // highlightText: ruleValue,
                                },
                              },
                            };
                            updateRulesRef.current = {
                              ...data,
                              ifRules: [...existingRule],
                            };
                            setData({
                              ...data,
                              ifRules: existingRule,
                            });
                          }
                          return;
                        }
                        if (ifRule.type === "input") {
                          const updatedRules = updateRuleValue({
                            rules: updateRulesRef.current.ifRules,
                            ruleValue,
                            ruleId: ifRule.value,
                            isGroupRule: ifRule.isGroupRule,
                          });
                          setData({
                            ...data,
                            ifRules: updatedRules,
                          });
                          return;
                        }
                        let existingRule = [...data.ifRules];
                        const selectedRule = rulesStructure[data.ruleType]?.[
                          creteria
                        ]?.ifRules?.find((item) => item.value === ruleValue);
                        if (selectedRule) {
                          existingRule = [...existingRule, selectedRule];
                        }
                        const ifRuleArray = data.ifRules.some((item) =>
                          rulesStructure[data.ruleType]?.[creteria]?.ifRules?.find(
                            (_item) => _item.value === item.value
                          )
                        );
                        if (ifRuleArray) {
                          let findRule = data.ifRules.find((item) =>
                            rulesStructure[data.ruleType]?.[creteria]?.ifRules?.find(
                              (_item) => _item.value === item.value
                            )
                          );
                          if (findRule) {
                            existingRule = existingRule.filter(
                              (item) => item.value !== findRule?.value
                            );
                          }
                        }
                        setData({
                          ...data,
                          ifRules: existingRule,
                        });
                      }}
                      rules={selectedRuleTypeRules.ifRules}
                      type={ifRule.groupRule?.groupRule?.type}
                      inputType={ifRule.groupRule?.groupRule?.inputType}
                      listType={ifRule.groupRule?.groupRule?.listType}
                      ruleId={ifRule.groupRule?.groupRule?.value}
                      inputValue={ifRule.groupRule?.groupRule.selectedValue}
                      isGroupRule={true}
                      showError={ifRule?.groupRule?.groupRule?.isShowError}
                    />
                    {<span>{ifRule?.groupRule?.groupRule?.endTitle}</span>}
                  </>
                )}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default IfRuleView;